export enum VIPProductService {
  GET_COLLECTION_AND_ACTIVITIES = 'vipProduct/collectionsAndActivities',
  GET_ACTIVITIES_AND_CATEGORIES = 'vipProduct/activitiesAndCategories'
}
